export const getRibbonExperiments = (feature: string) => {
    return (
        feature === 'ReactMultilineRibbonIsEnabled' ||
        feature === 'ShyRibbonIsEnabled' ||
        feature === 'ReactSharedHeaderIsEnabled' ||
        feature === 'RibbonPaddlesIsEnabled' ||
        feature === 'ShouldMergeAppToggleButtonMenuItemStyles' ||
        feature === 'DelayRenderTooltipsIsEnabled' ||
        feature === 'SharedOnline.ChangeGate.MultiWindowSupportIsEnabled' ||
        feature === 'SharedOnline.ChangeGate.ShouldMergeStylesIntoMenuItems'
    );
};
